import Vue from 'vue';
import Router from 'vue-router';
const fb = require('./firebaseConfig.js');
const db = fb.default.db;
import Home from './views/Home.vue';
import Screen2 from './views/Screen2.vue';



Vue.use(Router);

let router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/screen2",
      name: "screen2",
      component: Screen2
    },
    {
      path: '*',
      redirect: '/home',
    },
  ]
});



export default router;
